<template>
    <div style="position: relative;" ref="notice_post_wrap">
        <div style="">
            <div style="display: flex; gap: 8px;">
                <div>
                    <div style="width: 40px; display: flex; justify-content: center; align-items: center; height: 40px; border: 2px solid #d9d9d9; border-radius: 50%; background-color: #f5f5f5;">
                        <img v-if="noticePost.notice_type === NOTICE_TYPE.NOTICE" style="width: 22px;" :src="require('@/assets/img/logo_notice.png')" alt="">
                        <img v-else style="width: 18px;" :src="require('@/assets/img/logo_event.png')" alt="">
                    </div>
                </div>
                <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
                    <div @click="showPage(noticePost.notice_type)" style="display: flex; align-items: center; gap: 2px;">
                        <div style="font-weight: 500; font-size: 12px; color: var(--color-main); line-height: 20px;">{{ noticePost.notice_type === NOTICE_TYPE.NOTICE ? '공지사항' : '이벤트' }}</div>
                        <img style="width: 4px;" :src="require('@/assets/img/arrow_orange_new.png')" alt="">
                    </div>
                    <div @click="showDetail">
                        <div style="font-size: 15px; font-weight: 500; line-height: 18px; margin-bottom: 4px;">{{ noticePost.title }}</div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #4b8aff;">{{ noticePost.outside_btn_name }}</div>
                    </div>
                </div>
                <div v-if="noticePost.is_hidden_btn_show === NOTICE_HIIDEN_BTN_SHOW.SHOW" @click="confirmHideNotice" style="flex-basis: 31px; text-align: right;">
                    <img style="width: 7px;" :src="require('@/assets/img/poll_hide_btn.png')" alt="">
                </div>
            </div>
        </div>
        <template v-if="bookmarkFlag">
            <BookmarkPopup :background="'#fff'" :height="306" :isShowBookmarkPopup="isShowBookmarkPopup" :closeBookmarkPopup="closeBookmarkPopup">
                <div>
                    <div @click="closeBookmarkPopup(false)" style="font-weight: 700;">닫기</div>
                    <div style="text-align: center; margin-top: 32px;">
                        <div style="font-weight: 700; font-size: 20px; line-height: 24px;">이 공지·이벤트 피드를 숨기시겠어요?</div>
                        <div style="margin-top: 20px; color: #606060; font-weight: 500; line-height: 24px;">지금 보신 공지는 피드에서 더 이상 표시되지 않아요.<br>하지만 새 공지나 이벤트가 생기면 다시 안내해드릴게요.</div>
                        <div @click="hideNotice" style="width: 186px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">확인</div>
                    </div>
                </div>
            </BookmarkPopup>
        </template>
    </div>
</template>

<script>
import { NOTICE_TYPE, NOTICE_HIIDEN_BTN_SHOW } from '@/Constants'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup'
import ResponseCode from "../../ResponseCode";

export default {
    name: 'CommonNoticePost',
    components: { BookmarkPopup },
    props: {
        noticePost: {
            type: Object,
            default: () => { }
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        index: {
            type: Number,
            default: -1
        },
        isFeed: {
            type: Boolean,
            default: false
        },
        isPopular: {
            type: Boolean,
            default: false
        },
        showPopularPostPopup: {
            type: Function,
            default: () => { }
        },
        isNeedWrittenCheck: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            NOTICE_TYPE: NOTICE_TYPE,
            isShowBookmarkPopup: false,
            bookmarkFlag: false,
            NOTICE_HIIDEN_BTN_SHOW: NOTICE_HIIDEN_BTN_SHOW,
            notice_view_interval: null
        }
    },
    watch: {

    },
    deactivated() {
        if (this.notice_view_interval) clearInterval(this.notice_view_interval);
    },
    created() {
        this.hideNotice = this.$Once(this.hideNotice)
        if (this.$GlobalStore.isLogin()) {
            this.notice_view_interval = setInterval(async () => {
                if(!this.$refs.notice_post_wrap) return;

                const cur_rect = this.$refs.notice_post_wrap.getBoundingClientRect();

                const component_gap = 80;
                if (cur_rect.top + component_gap < window.innerHeight && cur_rect.top + component_gap > 0) {
                    const parameters = {};
                    parameters.notice_idx = this.noticePost.idx;
                    const res = await this.$Axios.post('/api/notice/set_view', parameters);
                    if (res.data.code === ResponseCode.SUCCESS) {
                        if (this.notice_view_interval) clearInterval(this.notice_view_interval);
                    }
                }
            }, 2000);
        }

    },
    methods: {
        closeBookmarkPopup() {
            this.isShowBookmarkPopup = false
            setTimeout(() => {
                this.bookmarkFlag = false
            }, 510)
        },
        async showPage(noticeType) {
            if (this.isNeedWrittenCheck) {
                const isWrittenRequestForm = await this.$Util.checkIsWriteRequestForm()
                if (!isWrittenRequestForm) {
                    return
                }
            }
            this.$GlobalStore.addModal('Notification', { noticeType: noticeType })
        },
        async showDetail() {
            if (this.isNeedWrittenCheck) {
                const isWrittenRequestForm = await this.$Util.checkIsWriteRequestForm()
                if (!isWrittenRequestForm) {
                    return
                }
            }
            this.$GlobalStore.addModal('NoticeDetail', { notice_idx: this.noticePost.idx, isClickOutside: true })
        },
        confirmHideNotice() {
            if (!this.isPopular) {
                this.bookmarkFlag = true
                setTimeout(() => {
                    this.isShowBookmarkPopup = true
                }, 10)
            } else {
                this.showPopularPostPopup(this.noticePost, this.index)
            }
        },
        async hideNotice() {
            const formData = new FormData()
            formData.append('notice_idx', this.noticePost.idx)

            const res = await this.$Axios.post('/api/notice/hide', formData)

            if (res.data.code === 0) {
                this.completeAction(this.isFeed, this.index, this.noticePost.notice_type)
                this.closeBookmarkPopup()
            }
        }
    }

}
</script>

<style scoped>
.poll_btn {
    width: 270px;
    border: 1px solid #ebebeb;
    border-radius: 50px;
    padding: 12px 20px;
    font-size: 12px;
    font-weight: 500;
    position: relative;
    min-height: 41px;
    overflow: hidden;
}

.not_complete {
    transform: translateX(-50%);
    left: 50%;
}

.complete {
    transform: translateX(0%);
    left: 20px;
}

.progress_bar {
    position: absolute;
    transition: all 0.3s;
    width: 0%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 50px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>